<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CBPf5Y/tc-custom/9780226181608.jpg?1722571969613" alt="This image is the cover for the book Hercules in the Cradle, American Beginnings, 1500–1900"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hercules in the Cradle, American Beginnings, 1500–1900
      </h1>
      <p class="bookDescription body article font2">
        <p>Two and a half centuries after the American Revolution the United States stands as one of the greatest powers on earth and the undoubted leader of the western hemisphere. This stupendous evolution was far from a foregone conclusion at independence. The conquest of the North American continent required violence, suffering, and bloodshed. It also required the creation of a national government strong enough to go to war against, and acquire territory from, its North American rivals.<br/><br/> In <i>A Hercules in the Cradle</i>, Max M. Edling argues that the federal government’s abilities to tax and to borrow money, developed in the early years of the republic, were critical to the young nation’s ability to wage war and expand its territory. He traces the growth of this capacity from the time of the founding to the aftermath of the Civil War, including the funding of the War of 1812 and the Mexican War. Edling maintains that the Founding Fathers clearly understood the connection between public finance and power: a well-managed public debt was a key part of every modern state. Creating a debt would always be a delicate and contentious matter in the American context, however, and statesmen of all persuasions tried to pay down the national debt in times of peace. <i>A Hercules in the Cradle</i> explores the origin and evolution of American public finance and shows how the nation’s rise to great-power status in the nineteenth century rested on its ability to go into debt.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Max M. Edling
      </h2>
      
      <p class="authorDescription body article"><B>Max M. Edling</B> is a lecturer in North American history at King’s College London and the author of <I>A Revolution in Favor of Government: Origins of the U.S. Constitution and the Making of the American State</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?03f77f73